const s = sessionStorage.getItem("ASSET_URL"), e = {
  GENERAL: `${s}/icon/general`,
  VISUAL: `${s}/icon/visual`,
  TESS: `${s}/icon/tess`
};
export {
  e as I
};
